import React from 'react';

function Services() {
  const services = [
    { 
      icon: '👔', 
      title: 'Staff Transport', 
      desc: 'Daily pick-up and drop-off for companies, factories, and construction sites.' 
    },
    { 
      icon: '🎒', 
      title: 'School Transportation', 
      desc: 'RTA-approved school buses with trained drivers and supervisors.' 
    },
    { 
      icon: '🏙️', 
      title: 'City Tours', 
      desc: 'Dubai, Abu Dhabi, Sharjah, Ajman, Fujairah, RAK — full UAE coverage.' 
    },
    { 
      icon: '🏜️', 
      title: 'Desert Safari', 
      desc: 'Group transport for safari operators and tourism companies.' 
    },
    { 
      icon: '✈️', 
      title: 'Airport Transfers', 
      desc: 'Group arrivals, departures, and hotel shuttle services.' 
    },
    { 
      icon: '📅', 
      title: 'Bus Rental', 
      desc: 'Daily • Weekly • Monthly • Long-Term Contracts' 
    }
  ];

  return (
    <section id="services" className="services-section">
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Complete transportation solutions for every requirement
          </p>
        </div>
        <div className="row">
          {services.map((service, idx) => (
            <div key={idx} className="col-lg-4 col-md-6 mb-4">
              <div className="service-card">
                <div className="service-icon">{service.icon}</div>
                <h4 className="service-title">{service.title}</h4>
                <p className="service-desc">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;